var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.02238 0.822183C0.592801 1.25176 0.592801 1.94824 1.02238 2.37782L4.64456 6L1.02238 9.62218C0.592802 10.0518 0.592802 10.7482 1.02238 11.1778C1.45196 11.6074 2.14844 11.6074 2.57801 11.1778L6.97801 6.77782C7.40759 6.34824 7.40759 5.65176 6.97801 5.22218L2.57801 0.822182C2.14844 0.392606 1.45195 0.392606 1.02238 0.822183Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.9aba3073.svg";
export { ForwardRef as ReactComponent };